import { GlobalState } from '@highlight/ipc'

export const getNetworkStatus = () => {
  return GlobalState.get('networkStatus') || 'pending'
}

export const isNetworkOnline = () => {
  return getNetworkStatus() === 'online'
}

export const isNetworkOffline = () => {
  return getNetworkStatus() === 'offline'
}

/** GlobalState key for the last offline→online transition (epoch ms). */
export const NETWORK_BACK_ONLINE_AT_KEY = 'networkBackOnlineAt'

/** When the network most recently came back from offline, or null if it has
 *  not dropped since launch. */
export const getNetworkBackOnlineAt = (): number | null => {
  return GlobalState.get<number | null>(NETWORK_BACK_ONLINE_AT_KEY, null)
}
